module.exports = __webpack_public_path__ + "img/marvin.68ec1fe7.jpg";